import * as types from './constants';

// Get Billing Transactions
export const getBillingTransactionsRequest = data => (
  { type: types.GET_BILLING_TRANSACTIONS_REQUEST, payload: data }
);

export const getBillingTransactionsDone = data => (
  { type: types.GET_BILLING_TRANSACTIONS_DONE, payload: data }
);

export const getBillingTransactionsFailed = errors => (
  { type: types.GET_BILLING_TRANSACTIONS_FAILED, payload: errors }
);

export const getBillingTransactionsReset = () => (
  { type: types.GET_BILLING_TRANSACTIONS_RESET }
);

export const billingTransactionsSetPage = data => (
  { type: types.BILLING_TRANSACTIONS_SET_PAGE, payload: data }
);